import React from "react";
import { PasswordInputField } from "@jsainsburyplc/id-ui-common";
import SectionContainer from "./SectionContainer";

import { PASSWORD, CONFIRM_PASSWORD } from "constants/registrationForm";

const MyAccount = ({
  myAccountData: { label, elements },
  firstName,
  lastName,
  userEmail,
}) => (
  <SectionContainer label={label}>
    <input
      name="username"
      defaultValue={userEmail}
      autoComplete="username"
      style={{ display: "none" }}
    />
    {elements[PASSWORD] && (
      <PasswordInputField
        name={PASSWORD}
        placeholder="Enter your password"
        label="Password"
        hasPasswordCheck={true}
        firstName={firstName}
        lastName={lastName}
        userEmail={userEmail}
        autoComplete="new-password"
      />
    )}
    {elements[CONFIRM_PASSWORD] && (
      <PasswordInputField
        name={CONFIRM_PASSWORD}
        label="Confirm password"
        placeholder="Confirm your password"
        autoComplete="new-password"
      />
    )}
  </SectionContainer>
);

export default MyAccount;
